import { createMuiTheme } from '@material-ui/core';

/**
 * material-uiのテーマ情報を設定
 */
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#ac723e',
    },
  },
});

export default theme;
